const getContentfulSrc = (image, formatTag, width = '') => {
    return `${image}?${formatTag}&w=${width}&q=85 ${width}w`;
};
const getContentfulSrcSet = (image, formatTag, widths) => {
    return widths.map((width) => getContentfulSrc(image, formatTag, `${width}`)).join(',\n');
};

export { getContentfulSrc, getContentfulSrcSet };
//# sourceMappingURL=contentfulUtils.js.map
